// @flow strict
import styled from "styled-components";

const Title = styled.h2`
  margin-bottom: 2rem;
`;

export default Title;
